import { Reducer } from 'redux';
import { SingleResourceLoadingState } from '../../common/store/stateHelpers';

export enum ActionType {
    RequestGenerateApiKey = 'WIDGETSETTINGS/REQUEST_GENERATEAPIKEY',
    ReceivedGenerateApiKey = 'WIDGETSETTINGS/RECEIVED_GENERATEAPIKEY',
    RequestTestPartnerApiKey = 'WIDGETSETTINGS/REQUEST_TESTPARTNERAPIKEY',
    ReceivedTestPartnerApiKey = 'WIDGETSETTINGS/RECEIVED_TESTPARTNERAPIKEY'
}

export interface RequestGenerateApiKeyAction {
    type: ActionType.RequestGenerateApiKey
}

export interface ReceivedGenerateApiKeyAction {
    type: ActionType.ReceivedGenerateApiKey;
    apiKey: string;
}

export interface RequestTestPartnerApiKeyAction {
    type: ActionType.RequestTestPartnerApiKey
}

export interface ReceivedTestPartnerApiKeyAction {
    type: ActionType.ReceivedTestPartnerApiKey;
    testPartnerApiKey: string;
}

export const actionCreators = {
    RequestGenerateApiKey: () => <RequestGenerateApiKeyAction>{ type: ActionType.RequestGenerateApiKey},
    ReceivedGenerateApiKey: (apiKey: string | undefined) => <ReceivedGenerateApiKeyAction>{ type: ActionType.ReceivedGenerateApiKey, apiKey },
    RequestTestPartnerApiKey: () => <RequestTestPartnerApiKeyAction>{ type: ActionType.RequestTestPartnerApiKey},
    ReceivedTestPartnerApiKey: (testPartnerApiKey: string | undefined) => <ReceivedTestPartnerApiKeyAction>{ type: ActionType.ReceivedTestPartnerApiKey, testPartnerApiKey }
}

export interface WidgetSettingsModel {
    apiKey: string;
}

export interface PartnerApiSettingsModel {
    testPartnerApiKey: string;
}

export interface WidgetSettingsState {
    widgetSettings: SingleResourceLoadingState<WidgetSettingsModel>,
    partnerApiSettings: SingleResourceLoadingState<PartnerApiSettingsModel>
}

const initialState: WidgetSettingsState = {
    widgetSettings: {
        isLoading: false,
        data: undefined
    },
    partnerApiSettings: {
        isLoading: false,
        data: undefined
    }
}

type WidgetSettingsAction = RequestGenerateApiKeyAction | ReceivedGenerateApiKeyAction | RequestTestPartnerApiKeyAction | ReceivedTestPartnerApiKeyAction;

export const reducer: Reducer<WidgetSettingsState> = (state: WidgetSettingsState, action: WidgetSettingsAction) => {
    switch (action.type) {
        case ActionType.RequestGenerateApiKey:
            return {
                ...state,
                widgetSettings: {
                    ...state.widgetSettings,
                    isLoading: true
                }
            };
        case ActionType.ReceivedGenerateApiKey:
            return {
                ...state,
                widgetSettings: {
                    ...state.widgetSettings,
                    isLoading: false,
                    data: {
                        ...state.widgetSettings.data,
                        apiKey: action.apiKey
                    }
                }
            };
        case ActionType.RequestTestPartnerApiKey:
            return {
                ...state,
                partnerApiSettings: {
                    ...state.partnerApiSettings,
                    isLoading: true
                }
            };
        case ActionType.ReceivedTestPartnerApiKey:
            return {
                ...state,
                partnerApiSettings: {
                    ...state.partnerApiSettings,
                    isLoading: false,
                    data: {
                        ...state.partnerApiSettings.data,
                        testPartnerApiKey: action.testPartnerApiKey
                    }
                }
            };
        default:
            const exCheck: never = action;
    }
    return state || initialState;
}




// WEBPACK FOOTER //
// ./src/account/store/WidgetSettingsStore.ts